// Lazy YouTube embeds (snippets/usp-videos.liquid): the player is inserted only after a click.
(function () {
  if (window.uspVideoInit) return;
  window.uspVideoInit = true;
  document.addEventListener('click', function (e) {
    var btn = e.target instanceof Element ? e.target.closest('[data-usp-video]') : null;
    if (!btn) return;
    var id = btn.getAttribute('data-usp-video');
    if (!/^[A-Za-z0-9_-]{11}$/.test(id)) return;
    var frame = btn.querySelector('.usp-video__frame');
    var iframe = document.createElement('iframe');
    iframe.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
    iframe.title = (btn.getAttribute('aria-label') || 'Video').replace(/^Play video: /, '');
    iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen';
    iframe.allowFullscreen = true;
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';
    frame.innerHTML = '';
    frame.appendChild(iframe);
    // keep the title, but the box is no longer a button
    var box = document.createElement('div');
    box.className = btn.className + ' is-playing';
    while (btn.firstChild) box.appendChild(btn.firstChild);
    btn.replaceWith(box);
  });
})();
